
import React from 'react';
import NetworkStatus from './NetworkStatus';
// Temporarily disable OfflineIndicator to test if it's causing the hook error
// import OfflineIndicator from './OfflineIndicator';

const AppIndicators: React.FC = () => {
  return (
    <>
      <NetworkStatus />
      {/* Temporarily commented out to test hook stability */}
      {/* <OfflineIndicator /> */}
    </>
  );
};

export default AppIndicators;
